var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chart"}},[_c('Apexchart',{attrs:{"type":"area","height":"350","options":_vm.defaultOptions,"series":_vm.defaultDatasets}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }